// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TermsAndConditions_container__NrkFr {
    padding: 20px;
    max-width: 900px;
    margin: 5em auto;
  }
  
  .TermsAndConditions_title__XExZQ {
    text-align: center;
    font-size: 2.5rem;
    margin-bottom: 20px;
  }
  
  .TermsAndConditions_introduction__fpznG {
    font-size: 1.2rem;
    margin-bottom: 20px;
    text-align: center;
  }
  
  .TermsAndConditions_subTitle__vqJUr {
    font-size: 1.8rem;
    margin-top: 20px;
    color: #333;
  }
  
  .TermsAndConditions_text__4Pa3H {
    font-size: 1rem;
    line-height: 1.6;
    color: #666;
    margin-bottom: 15px;
  }
  
  @media (max-width: 768px) {
    .TermsAndConditions_container__NrkFr {
      padding: 15px;
    }
  
    .TermsAndConditions_title__XExZQ {
      font-size: 2rem;
    }
  
    .TermsAndConditions_subTitle__vqJUr {
      font-size: 1.5rem;
    }
  
    .TermsAndConditions_text__4Pa3H {
      font-size: 0.95rem;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/TermsAndConditions/TermsAndConditions.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE;MACE,aAAa;IACf;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,kBAAkB;IACpB;EACF","sourcesContent":[".container {\n    padding: 20px;\n    max-width: 900px;\n    margin: 5em auto;\n  }\n  \n  .title {\n    text-align: center;\n    font-size: 2.5rem;\n    margin-bottom: 20px;\n  }\n  \n  .introduction {\n    font-size: 1.2rem;\n    margin-bottom: 20px;\n    text-align: center;\n  }\n  \n  .subTitle {\n    font-size: 1.8rem;\n    margin-top: 20px;\n    color: #333;\n  }\n  \n  .text {\n    font-size: 1rem;\n    line-height: 1.6;\n    color: #666;\n    margin-bottom: 15px;\n  }\n  \n  @media (max-width: 768px) {\n    .container {\n      padding: 15px;\n    }\n  \n    .title {\n      font-size: 2rem;\n    }\n  \n    .subTitle {\n      font-size: 1.5rem;\n    }\n  \n    .text {\n      font-size: 0.95rem;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `TermsAndConditions_container__NrkFr`,
	"title": `TermsAndConditions_title__XExZQ`,
	"introduction": `TermsAndConditions_introduction__fpznG`,
	"subTitle": `TermsAndConditions_subTitle__vqJUr`,
	"text": `TermsAndConditions_text__4Pa3H`
};
export default ___CSS_LOADER_EXPORT___;
